"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _phoneDecorator = require("./helpers/phoneDecorator");

var _excluded = ["placeholder", "errorMessage", "className", "onChange", "name", "initialValue"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var INITIAL = 7;

var phoneDecorator = function phoneDecorator(Input) {
  return function (props) {
    var placeholder = props.placeholder,
        errorMessage = props.errorMessage,
        className = props.className,
        onChange = props.onChange,
        name = props.name,
        initialValue = props.initialValue,
        rest = _objectWithoutProperties(props, _excluded);

    var input = (0, _react.useRef)({});

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isValid = _useState2[0],
        setIsValid = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isNotValid = _useState4[0],
        setIsNotValid = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isTouch = _useState6[0],
        setIsTouch = _useState6[1];

    var _useState7 = (0, _react.useState)(initialValue),
        _useState8 = _slicedToArray(_useState7, 2),
        value = _useState8[0],
        setValue = _useState8[1];

    var onChangeHandler = function onChangeHandler(event) {
      event.preventDefault();
      var value = (0, _phoneDecorator.replaceValueForPhone)(event.target.value);
      setValue(value);
      checkValidate(value);
    };

    var onFocusHandler = function onFocusHandler() {
      if (!isTouch) setIsTouch(true);

      if (!value || !value.length) {
        setValue(INITIAL);
        var timeout = setTimeout(function () {
          input.current.setSelectionRange(3, 3);
          clearTimeout(timeout);
        }, 150);
      }
    };

    var onBlurHandler = function onBlurHandler() {
      if (value.length !== 11) setIsNotValid(true);
    };

    var checkValidate = function checkValidate(value) {
      if (value && value.length === 11) {
        setIsValid(true);
        setIsNotValid(false);
      } else {
        setIsValid(false);
      }
    };

    var clearInput = function clearInput() {
      setIsTouch(false);
      setValue('');
      setIsValid(false);
    };

    (0, _react.useEffect)(function () {
      if (value && value !== INITIAL) {
        onChange({
          value: value,
          isValid: isValid,
          clearInput: clearInput
        });
      }
    }, [value, isValid]);
    (0, _react.useEffect)(function () {
      setValue(initialValue);
    }, [initialValue]);
    (0, _react.useEffect)(function () {
      checkValidate(value);
    }, [value]);
    return /*#__PURE__*/_react["default"].createElement(Input, _extends({
      value: isTouch || Boolean(value) ? (0, _phoneDecorator.formatValueForPhone)(value) : '',
      name: name,
      placeholder: placeholder,
      showText: true,
      errorMessage: errorMessage,
      isNotValid: isNotValid,
      inputType: "phone",
      isValid: isValid,
      className: className,
      onChange: onChangeHandler,
      onPaste: onChangeHandler,
      onFocus: onFocusHandler,
      onBlur: onBlurHandler,
      ref: input
    }, rest));
  };
};

phoneDecorator.PropTypes = {
  placeholder: _propTypes["default"].string,
  name: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  initialValue: _propTypes["default"].string
};
phoneDecorator.defaultProps = {
  placeholder: 'Номер телефона',
  name: 'phone',
  errorMessage: 'Введите телефон в формате +7 (999) 999-99-99',
  className: '',
  onChange: function onChange() {
    return null;
  },
  initialValue: ''
};
var _default = phoneDecorator;
exports["default"] = _default;